import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const SPANISH_MOBILE_PATTERN = /^[679]\d{8}$/;

export function optionalSpanishMobileValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const raw = control.value;
    if (raw == null || String(raw).trim() === '') {
      return null;
    }
    const digits = String(raw).replace(/\D/g, '');
    return SPANISH_MOBILE_PATTERN.test(digits) ? null : { mobilePhone: true };
  };
}

export function normalizeSpanishMobilePhone(value: unknown): string | undefined {
  if (value == null) {
    return undefined;
  }
  const digits = String(value).replace(/\D/g, '');
  if (digits === '') {
    return undefined;
  }
  return digits;
}
